"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTick = void 0;
var enumsAi_1 = require("./enumsAi");
var diveAi_zombie_sidecar_1 = require("./diveAi_zombie-sidecar");
var diveDebug_sidecar_1 = require("@dive/debug/diveDebug-sidecar");
var diveAi_spider_sidecar_1 = require("./diveAi_spider-sidecar");
function updateTick(obj) {
    if (obj.isDead || obj.isDying || obj.hitpoints <= 0) {
        return;
    }
    if (diveDebug_sidecar_1.diveDebug.debug_noEnemyAi) {
        return;
    }
    if (obj.ai.mode === enumsAi_1.EAiMode.Zombie) {
        diveAi_zombie_sidecar_1.diveAi_zombie.updateTick(obj);
    }
    if (obj.ai.mode === enumsAi_1.EAiMode.Spider) {
        diveAi_spider_sidecar_1.diveAi_spider.updateTick(obj);
    }
}
exports.updateTick = updateTick;
